import type { FunctionalComponent, SVGAttributes } from 'vue'

export const RecordIcon: FunctionalComponent<SVGAttributes> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.9 19.2C5.9 19.4209 6.07909 19.6 6.3 19.6H17.7C17.9209 19.6 18.1 19.4209 18.1 19.2V7.74558C18.1 7.6395 18.0579 7.53776 17.9828 7.46274L15.0373 4.51716C14.9622 4.44214 14.8605 4.4 14.7544 4.4H6.3C6.07909 4.4 5.9 4.57909 5.9 4.8V19.2ZM15.6172 3.11716C15.5421 3.04214 15.4404 3 15.3343 3H4.9C4.67909 3 4.5 3.17909 4.5 3.4V20.6C4.5 20.8209 4.67909 21 4.9 21H19.1C19.3209 21 19.5 20.8209 19.5 20.6V7.16569C19.5 7.0596 19.4579 6.95786 19.3828 6.88284L15.6172 3.11716Z"
        fill="var(--colors-bg-icon-secondary)"
      />
      <path
        d="M7.5 13.4C7.5 13.1791 7.67909 13 7.9 13H16.1C16.3209 13 16.5 13.1791 16.5 13.4V14C16.5 14.2209 16.3209 14.4 16.1 14.4H7.9C7.67909 14.4 7.5 14.2209 7.5 14V13.4Z"
        fill="var(--colors-bg-icon-secondary)"
      />
      <path
        d="M7.5 16.4C7.5 16.1791 7.67909 16 7.9 16H14.1C14.3209 16 14.5 16.1791 14.5 16.4V17C14.5 17.2209 14.3209 17.4 14.1 17.4H7.9C7.67909 17.4 7.5 17.2209 7.5 17V16.4Z"
        fill="var(--colors-bg-icon-secondary)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.8008 3.9C13.8008 3.67909 13.9799 3.5 14.2008 3.5H14.8008C15.0217 3.5 15.2008 3.67909 15.2008 3.9V6.4C15.2008 6.62091 15.3799 6.8 15.6008 6.8H18.1008C18.3217 6.8 18.5008 6.97909 18.5008 7.2V7.8C18.5008 8.02091 18.3217 8.2 18.1008 8.2H14.2008C13.9799 8.2 13.8008 8.02091 13.8008 7.8V3.9Z"
        fill="var(--colors-bg-icon-secondary)"
      />
    </svg>
  )
}
